import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { Globe } from 'lucide-react';
import { localizePath, stripLocale } from '../src/i18n/supported';
import { TRANSLATED_PATHS } from '../src/i18n/translatedPaths';

const languages = [
  { code: 'en', name: 'English' },
  { code: 'zh', name: '中文' },
  { code: 'ar', name: 'العربية' },
  { code: 'es', name: 'Español' },
  { code: 'pt', name: 'Português' },
  { code: 'fr', name: 'Français' },
  { code: 'ru', name: 'Русский' },
];

export const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const handleLanguageChange = (code: string) => {
    const basePath = stripLocale(pathname);
    const hasTranslation =
      TRANSLATED_PATHS.includes(basePath) || /^\/product\/infrared-heaters\//.test(basePath);
    // Pages without a translated version fall back to that language's home page
    // rather than a prefixed URL that would 404.
    const target = hasTranslation
      ? localizePath(code, basePath)
      : code === 'en'
        ? '/'
        : `/${code}`;
    void i18n.changeLanguage(code);
    navigate(target);
  };

  return (
    <div className="relative group">
      <button className="flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors">
        <Globe size={20} />
      </button>

      <div className="absolute right-0 mt-2 w-40 bg-white dark:bg-gray-900 rounded-lg shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
        <div className="py-2">
          {languages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => handleLanguageChange(lang.code)}
              className={`w-full px-4 py-2 text-left text-sm hover:bg-gray-100 dark:hover:bg-gray-800 flex items-center gap-2 ${
                i18n.language === lang.code
                  ? 'text-blue-600 font-medium'
                  : 'text-gray-700 dark:text-gray-300'
              }`}
            >
              <span>{lang.name}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};
